// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { FrontendSettings } from '../../helpers/FrontendSettings'
import { filterCustomersByGPstatus } from '../../helpers/Utils'
import { useDebounce } from '../../hooks/useDebounce'
import { useSettings } from '../../hooks/useSettings'
import { useGetTenantsQuery } from '../../redux/api/customerApi'
import { State } from '../../redux/reducers/initialState'
import { IUserViewModel } from '../../types/interfaces'
import '../GeneralPage/GeneralPage.scss'
import { ContractStateEnum, FrontendSettingsKeys } from './../../types/enums'
import { ICustomerViewModel } from './../../types/interfaces'
import { LoadingSpinner } from '../common/LoadingSpinner/LoadingSpinner'
import Companies from './Companies/Companies'
import { useGetContractStatisticsQuery } from '../../redux/api/contractsApi'
import { ContractsGrouping } from '@ail/contracts-api'
import { ContactKind } from '@ail/customers-api'
import { Loader } from '../common/Loader/Loader'

function GeneralPage(props: { user?: IUserViewModel; selectedManager?: string; customers: ICustomerViewModel[] }) {
  const { t } = useTranslation('common')
  const { data: tenants = [] } = useGetTenantsQuery()
  const [expiringDaysFilter] = useSettings('expiringDaysFilter')
  const expiringDays = Number(expiringDaysFilter)
  const [loading, setLoading] = useState(false)
  const [statusFilter, setStatusFilter] = useState(
    FrontendSettings.get(FrontendSettingsKeys.generalPageStatusFilter) || 'ACTIVE'
  )
  const [searchString, setSearchString] = useState(
    FrontendSettings.get(FrontendSettingsKeys.generalPageSearchString) || ''
  )

  const { currentData: stats } = useGetContractStatisticsQuery({
    grouping: ContractsGrouping.ByExpiration,
  })

  const debouncedSearchString = useDebounce(searchString, 2000)

  const selectedManager = FrontendSettings.get(FrontendSettingsKeys.selectedManager)
  const selectedManagerEmail = selectedManager?.split(' | ')[0]
  const selectedManagerDisplayName = selectedManager?.split(' | ')[1]

  const prefilteredCustomers = useMemo(() => {
    const customersToPreFilter = selectedManager
      ? props.customers.filter((cust) => {
          if (
            cust.managers.filter(
              (man) =>
                man.contacts.filter((c) => c.kind === ContactKind.Email)[0]?.value === selectedManagerEmail ||
                man.displayName === selectedManagerDisplayName
            ).length > 0
          ) {
            return cust
          }
        })
      : props.customers
    return filterCustomersByGPstatus(customersToPreFilter, statusFilter)
  }, [props.customers, statusFilter, selectedManager])

  const countTotalExpiringContracts = useMemo(() => {
    let total = 0
    const arr2: {
      [key: string]: number
    }[] = []
    if (!stats) return 0
    if (selectedManager) {
      Object.keys(stats).map((obj) => {
        prefilteredCustomers.filter((el) => {
          if (obj.toLowerCase().indexOf(el.id.toLowerCase()) > -1) {
            arr2.push(stats[obj])
          }
        })
      })
    }

    const arr = Object.keys(stats).map((obj) => {
      return stats[obj]
    })
    const source = selectedManager ? arr2 : arr
    source.map((obj) => {
      Object.keys(obj).map((el) => {
        if (Number(el) <= expiringDays) {
          total += obj[el]
        }
      })
    })
    return total
  }, [prefilteredCustomers, stats, selectedManager, expiringDays])

  const contractsStats = useMemo(() => {
    const newStats = {
      total: 0,
      active: 0,
      closed: 0,
      initialized: 0,
    }

    if (props.customers && props.customers.length > 0) {
      const statusToCount = [
        ContractStateEnum.Closed,
        ContractStateEnum.Running,
        ContractStateEnum.Terminated,
        ContractStateEnum.Extended,
        ContractStateEnum.Initialized,
      ]

      const statusForActive = [ContractStateEnum.Running, ContractStateEnum.Extended]

      const statusForClosed = [ContractStateEnum.Closed, ContractStateEnum.Terminated]

      const statusForInitialized = [ContractStateEnum.Initialized]
      const source = selectedManager ? prefilteredCustomers : props.customers
      source.forEach((c) => {
        statusToCount.forEach((status) => {
          newStats.total += c.contracts[status] || 0
        })

        statusForActive.forEach((status) => {
          newStats.active += c.contracts[status] || 0
        })

        statusForClosed.forEach((status) => {
          newStats.closed += c.contracts[status] || 0
        })

        statusForInitialized.forEach((status) => {
          newStats.initialized += c.contracts[status] || 0
        })
      })
    }

    return newStats
  }, [props.customers, prefilteredCustomers])

  const sortedCustomers = useMemo(() => {
    if (prefilteredCustomers.length > 0) {
      const filteredSearch = debouncedSearchString ? debouncedSearchString.trim().toLowerCase() : ''
      const matchingTenant = filteredSearch
        ? tenants.filter((t) => t.name.toLowerCase().includes(filteredSearch))
        : undefined
      const filtered = filteredSearch
        ? prefilteredCustomers.filter((c) => {
            let tenants: string[] | undefined
            if (c.tenantId) {
              tenants = matchingTenant?.filter((t) => t.id === c.tenantId).map((t) => t.name.toLowerCase())
            }
            return (
              `${c.name} ${c.id} ${c.vatNumber} ${c.reference}`.toLowerCase().indexOf(filteredSearch) >= 0 ||
              (tenants && tenants.some((tenant) => tenant.includes(filteredSearch)))
            )
          })
        : [...prefilteredCustomers]
      return filtered.sort((a, b) => {
        return (a.name || '').localeCompare(b.name || '')
      })
    }
    return []
  }, [prefilteredCustomers, debouncedSearchString, tenants])

  useEffect(() => {
    if (props.selectedManager) {
      setLoading(true)
    }
  }, [props.selectedManager])

  useEffect(() => {
    setLoading(false)
  }, [sortedCustomers])

  function searchChanged(event?: React.ChangeEvent<HTMLInputElement>) {
    const value = event?.target.value ?? ''
    setSearchString(value)
    FrontendSettings.set(FrontendSettingsKeys.generalPageSearchString, value)
  }

  function customersFilterUpdated(e: React.ChangeEvent<HTMLSelectElement>) {
    FrontendSettings.set(FrontendSettingsKeys.generalPageStatusFilter, e.target.value)
    setStatusFilter(e.target.value)
  }

  return (
    <>
      <Loader blocking={loading}>
        <div className="row welcome-area">
          <div className="col-12 col-sm-6 col-lg-6 col-md-6">
            <div className="box white welcome">
              <div className="welcome-text">
                <div className="leftArea">
                  <strong>{t('GOOD_DAY')}</strong>
                  {props.customers.length > 6 && (
                    <div className="input-area">
                      <input
                        className="transparent"
                        type="text"
                        name={`fieldnameveryunique${new Date().getTime()}`}
                        autoComplete="none"
                        list="autocompleteOff"
                        onChange={searchChanged}
                        value={searchString}
                        placeholder={t('FIND_CUSTOMER_BY_KEYWORD')}
                      />
                      <button title={t('CLEAR')} className="clr-btn" onClick={() => searchChanged()}>
                        <span className="icon-clear" />
                      </button>
                      <i className="icon-search" />
                    </div>
                  )}
                </div>
                <div className="rightArea">
                  <strong>{t('FILTER_BY_STATUS')}</strong>
                  <div className="selectArea">
                    <select onChange={(e) => customersFilterUpdated(e)}>
                      <option selected={statusFilter === 'ALL'} value="ALL">
                        {t('ALL')}
                      </option>
                      <option selected={statusFilter === 'ACTIVE'} value="ACTIVE">
                        {t('ACTIVE')}
                      </option>
                      <option selected={statusFilter === 'CANCELED'} value="CANCELED">
                        {t('NOT_ACTIVE')}
                      </option>
                    </select>
                    <i className="icon-bottom"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-lg-6 col-md-6">
            <div className="box white summary">
              <div className="statsArea green">
                <i className="icon-contract rounded" />
                <div className="contract-abstract">
                  <strong>{contractsStats.active}</strong> {t('ACTIVE_CONTRACTS')}
                </div>
              </div>
              <div className="statsArea blue">
                <i className="icon-pending rounded" />
                <div className="contract-abstract">
                  <strong>{contractsStats.initialized}</strong> {t('INITIALISED_CONTRACTS')}
                </div>
              </div>
              <div className="statsArea orange">
                <i className="icon-expiring rounded" />
                <div className="contract-abstract">
                  <strong>{countTotalExpiringContracts}</strong>{' '}
                  {t('EXPIRING_CONTRACTS') +
                    ` (${expiringDays <= 90 ? expiringDays + ' ' + t('DAYS') : expiringDays / 30 + ' ' + t('MONTHS')})`}
                </div>
              </div>
            </div>
          </div>
        </div>
        <Companies
          tenants={tenants}
          selectedManager={props.selectedManager}
          companies={sortedCustomers}
          isAdmin={props.user?.isAdmin}
          isHomePage={true}
          isInternalUser={props.user?.isInternalUser}
          user={props.user}
        />
      </Loader>
    </>
  )
}

/**
 * decide what part of state should be exposed
 * @param state  redux state
 * @param ownProps props of component
 */
function mapStateToProps({ appData, customers }: State) {
  return {
    customers: customers.customers,
    selectedManager: appData.selectedManager,
    user: appData.currentUser,
  }
}

export default connect(mapStateToProps)(GeneralPage)
